// import React from "react";

// // My components
// import css from "../../css/common/card.module.css";

// function Card(props) {
//     return (
//         <div className={css.cardDiv}>
//             {props.type === "course" ? null : (
//                 <img
//                     className={css.cardImg}
//                     src={
//                         props.type === "vertical"
//                             ? props.data.imgSrc
//                             : props.data.vdoThumbnail
//                     }
//                     alt={props.data.name}
//                 />
//             )}
//             <div className={css.cardDetails}>
//                 <p className={css.cardName}>
//                     {props.type === "unit"
//                         ? props.data.video.title
//                         : props.data.name}
//                 </p>
//                 <p className={css.cardDesc}>
//                     {props.type === "unit"
//                         ? props.data.video.desc
//                         : props.data.desc}
//                 </p>

//                 <p className={css.cardCount}>
//                     {props.type === "vertical"
//                         ? props.data.courseCount + " Courses"
//                         : props.type === "course"
//                         ? props.data.unitCount + " Units"
//                         : props.data.activityCount +
//                           " Activities • " +
//                           props.data.quizCount +
//                           " Questions"}
//                 </p>
//                 <div className={css.cardBtns}>
//                     {props.type === "unit" ? null : (
//                         <button
//                             className={css.cardViewBtn}
//                             style={{
//                                 display: "inline",
//                                 width: "fit-content",
//                                 padding: "0 5% 0 5%",
//                                 backgroundColor: "var(--yuva-green)",
//                             }}
//                             id={props.data._id}
//                             onClick={(e) => {
//                                 props.onAddViewClick(e);
//                             }}
//                         >
//                             {props.isReadOnly ? 'View' : 'Add / View'}{" "}
//                             {props.type === "vertical"
//                                 ? "courses"
//                                 : props.type === "course"
//                                 ? "units"
//                                 : "unit"}
//                         </button>
//                     )}
//                     {!props.isReadOnly && (
//                     <button
//                         className={css.cardDltBtn}
//                         style={{
//                             display: "inline",
//                             width: "fit-content",
//                             padding: "0 5% 0 5%",
//                         }}
//                         id={props.data._id}
//                         onClick={(e) => {
//                             props.onDeleteClick(e);
//                         }}
//                     >
//                         <i
//                             id={props.data._id}
//                             style={{ color: "var(--card-dlt-red)" }}
//                             className="fa-sharp fa-solid fa-trash"
//                         ></i>
//                     </button>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Card;

// Card.jsx
import React from "react";
import css from "../../css/common/card.module.css";

function Card(props) {
    const {
        type,
        data,
        onAddViewClick,
        onDeleteClick,
        isReadOnly,
        // ── new props for visibility toggle ──
        showVisibilityToggle = false,
        isHidden = false,
        onToggleVisibility,
    } = props;

    return (
        <div className={css.cardDiv} style={isHidden ? { opacity: 0.65 } : {}}>
            {/* Dim card a bit when hidden – optional visual feedback */}

            {type === "course" ? null : (
                <img
                    className={css.cardImg}
                    src={type === "vertical" ? data.imgSrc : data.vdoThumbnail}
                    alt={data.name}
                />
            )}

            <div className={css.cardDetails}>
                <p className={css.cardName}>
                    {type === "unit" ? data.video.title : data.name}
                </p>

                <p className={css.cardDesc}>
                    {type === "unit" ? data.video.desc : data.desc}
                </p>

                <p className={css.cardCount}>
                    {type === "vertical"
                        ? `${data.courseCount || 0} Courses`
                        : type === "course"
                            ? `${data.unitCount || 0} Units`
                            : `${data.activityCount || 0} Activities • ${data.quizCount || 0} Questions`}
                </p>

                <div className={css.cardBtns}>
                    {type !== "unit" && (
                        <button
                            className={css.cardViewBtn}
                            style={{
                                display: "inline-block",
                                width: "fit-content",
                                padding: "0 5%",
                                backgroundColor: "var(--yuva-green)",
                            }}
                            id={data._id}
                            onClick={onAddViewClick}
                        >
                            {isReadOnly ? "View" : "Add / View"}{" "}
                            {type === "vertical" ? "courses" : type === "course" ? "units" : "unit"}
                        </button>
                    )}

                    {!isReadOnly && type !== "unit" && (
                        <button
                            className={css.cardDltBtn}
                            style={{ display: "inline-block", width: "fit-content", padding: "0 5%" }}
                            id={data._id}
                            onClick={onDeleteClick}
                        >
                            <i
                                id={data._id}
                                style={{ color: "var(--card-dlt-red)" }}
                                className="fa-sharp fa-solid fa-trash"
                            />
                        </button>
                    )}
                </div>

                {/* ── NEW: Visibility toggle for verticals ── */}
                {showVisibilityToggle && type === "vertical" && (
                    <div
                        className={css.visibilityControls}
                        style={{
                            marginTop: "12px",
                            paddingTop: "10px",
                            borderTop: "1px solid #eee",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontSize: "0.85rem",
                        }}
                    >
                        {isHidden && (
                            <span
                                style={{
                                    padding: "4px 10px",
                                    backgroundColor: "#fee2e2",
                                    color: "#b91c1c",
                                    borderRadius: "999px",
                                    fontWeight: 600,
                                    fontSize: "0.8rem",
                                }}
                            >
                                Hidden from users
                            </span>
                        )}

                        <button
                            type="button"
                            className="btn btn-sm"
                            style={{
                                background: isHidden ? "#16a34a" : "#dc2626",
                                color: "white",
                                border: "none",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // prevent bubbling to card click if any
                                onToggleVisibility?.(data._id, isHidden);
                            }}
                        >
                            {isHidden ? "Unhide Vertical" : "Hide Vertical"}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Card;